/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev } from '../../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import ComponentsCredit from '../../@sims/@components/credit'
import OverlayBg from '../../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Siswa';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'siswa';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [data_jurusan, set_data_jurusan] = useState(null);
    const [data_tingkatan_kelas, set_data_tingkatan_kelas] = useState(null);
    const [data_kelas, set_data_kelas] = useState(null);
    const [data_tahun, set_data_tahun] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')

    const [filter_kelas, set_filter_kelas] = useState('')
    const [filter_tahun, set_filter_tahun] = useState('')

    const [nis, set_nis] = useState('')
    const [nisn, set_nisn] = useState('')
    const [nama, set_nama] = useState('')
    const [tempat_lahir, set_tempat_lahir] = useState('')
    const [tanggal_lahir, set_tanggal_lahir] = useState('')
    const [jenis_kelamin, set_jenis_kelamin] = useState('')
    const [jurusan, set_jurusan] = useState('')
    const [tingkatan_kelas, set_tingkatan_kelas] = useState('')
    const [kelas, set_kelas] = useState('')
    const [orang_tua, set_orang_tua] = useState('')
    const [email, set_email] = useState('')
    const [no_hp, set_no_hp] = useState('')
    const [username, set_username] = useState('')
    const [password, set_password] = useState('')
    const [alamat, set_alamat] = useState('')
    const [tahun, set_tahun] = useState('')
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/siswa/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&kelas=' + filter_kelas
            + '&tahun=' + filter_tahun
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_jurusan = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_jurusan_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read jurusan', response.data)
            if(response.data.result == 'success'){
                set_data_jurusan(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_tingkatan_kelas = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_tingkatan_kelas_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read tingkatan kelas', response.data)
            if(response.data.result == 'success'){
                set_data_tingkatan_kelas(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_kelas = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_kelas_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read kelas', response.data)
            if(response.data.result == 'success'){
                set_data_kelas(response.data.data)
                set_filter_kelas(response.data.data.list[0].kelas)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_tahun = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_tahun_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read tahun', response.data)
            if(response.data.result == 'success'){
                set_data_tahun(response.data.data)
                set_filter_tahun(response.data.data.list[0].tahun)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {

        if(loading === true){
            return
        }
        
        if(search.length > 3){
    
            API_GET_REQUEST(`sims/siswa/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&kelas=' + filter_kelas
                + '&tahun=' + filter_tahun
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev('response search', response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = (action) => {

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);
        data.append("nis", nis);
        data.append("nisn", nisn);
        data.append("nama", nama);
        data.append("tempat_lahir", tempat_lahir);
        data.append("tanggal_lahir", tanggal_lahir);
        data.append("jenis_kelamin", jenis_kelamin);
        data.append("jurusan", jurusan);
        data.append("tingkatan_kelas", tingkatan_kelas);
        data.append("kelas", kelas);
        data.append("orang_tua", orang_tua);
        data.append("email", email);
        data.append("no_hp", no_hp);
        data.append("username", username);
        data.append("password", password);
        data.append("alamat", alamat);
        data.append("tahun", tahun);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + "sims/siswa/post__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev('response uploads', response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
                set_nis('')
                set_nisn('')
                set_nama('')
                set_tempat_lahir('')
                set_tanggal_lahir('')
                set_jenis_kelamin('')
                set_jurusan('')
                set_tingkatan_kelas('')
                set_kelas('')
                set_orang_tua('')
                set_email('')
                set_no_hp('')
                set_username('')
                set_password('')
                set_alamat('')
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }

    const _uploads_post = (params) => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('sims/siswa/post__________', {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
		}).then((response) => {
            console_dev('response upload post', response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== null){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                // _read(1, storage_bamboo)
                _read_jurusan(storage_bamboo)
                _read_tingkatan_kelas(storage_bamboo)
                _read_kelas(storage_bamboo)
                _read_tahun(storage_bamboo)
            }

        }else{

            error('User Not Found')
        
        }

    }

    const _STORAGE_USER_ONLY_READ = () => {

        if(STORAGE_USER !== null){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _read(1, storage_bamboo)
            }

        }else{

            error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(STORAGE_USER !== undefined){
        if(STORAGE_USER[0].level === 'guest'){
            history.push('/')
        }
    }else{
        history.push('/home')
        window.location.reload();
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            if(filter_kelas && filter_tahun){
                _STORAGE_USER_ONLY_READ()
            }else{
                _STORAGE_USER()
            }
        }

    }, [refresh, search])

    useEffect(() => {

        if(filter_kelas && filter_tahun){
            _STORAGE_USER_ONLY_READ()
        }

    }, [filter_kelas])

    useEffect(() => {

        if(filter_kelas && filter_tahun){
            _STORAGE_USER_ONLY_READ()
        }

    }, [filter_tahun])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <div style={{padding: 20}}>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Header ------------------------------------------------------------------ */}
            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>{meta_title}</h1>
                </div>
            </div>
            
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Laporan {meta_title}</p>
            </div>
            {/*  End Header --------------------------------------------------------------- */}

            {/*  Add ---------------------------------------------------------------------- */}
            <div className="_row _center_align _push_b_d _no_print">
                <div className="_column">
                    <div className="_font_size_20px">Data Cloud <ion-icon name="cloud-done-outline" style={{fontSize: 30, marginBottom: -6, marginLeft: 8, color: 'seagreen'}}></ion-icon></div>
                </div>
                <div>
                    <div onClick={() => {
                        window.print()
                    }} className="_btn _cursor_pointer">
                        Print
                    </div>

                    {
                        element === 'overlay' ?
                            <>
                                <div className="_fmc_overlay">
                                    <div className="_fmc_overlay_navbar">
                                        <div className="_row _center_align">
                                            <div className="_column">
                                                <p className="_font_size_18px">Tambah Data</p>
                                            </div>
                                            <div onClick={() => {
                                                if(element === 'overlay'){
                                                    set_element(null)
                                                }else{
                                                    set_element('overlay')
                                                }
                                            }} className="_push_l_d _btn _cursor_pointer">
                                                Keluar
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_fmc_overlay_content">
                                        <div className="_container">
                                            <div className="_lily_pad_h_d">
                                                <div className="_row _push_t_g _push_b_g">
                                                    <div className="_column">
                                                        <div className="_heading_bold _push_b_l">
                                                            Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                NIS
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => {
                                                                        set_nis(e.target.value)
                                                                        set_username(e.target.value)
                                                                        set_password(e.target.value)
                                                                    }}
                                                                    value={nis}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                NISN
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_nisn(e.target.value)}
                                                                    value={nisn}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Nama
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_nama(e.target.value)}
                                                                    value={nama}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Tempat Lahir
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_tempat_lahir(e.target.value)}
                                                                    value={tempat_lahir}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Tanggal Lahir
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_tanggal_lahir(e.target.value)}
                                                                    value={tanggal_lahir}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Jenis Kelamin
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_jenis_kelamin(e.target.value)}
                                                                    value={jenis_kelamin}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Jurusan
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_column">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            onChange={e => set_jurusan(e.target.value)}
                                                                            value={jurusan}
                                                                        />
                                                                    </div>
                                                                    <div onClick={() => {
                                                                        if(sub_element === 'dropdown_jurusan'){
                                                                            set_sub_element(null)
                                                                        }else{
                                                                            set_sub_element('dropdown_jurusan')
                                                                        }
                                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_jurusan' ? '#eee' : null}}>
                                                                        <div className="_row _center_align">
                                                                            <div className="_push_t_t">
                                                                                {
                                                                                    sub_element === 'dropdown_jurusan' ?
                                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                    :
                                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_relative">
                                                                    {
                                                                        sub_element === 'dropdown_jurusan' ?
                                                                            // _left or _right
                                                                            <>
                                                                                <div className="_fmc_overlay_dropdown _right">
                                                                                    {
                                                                                        data_jurusan && data_jurusan.list.map((item, index) => (
                                                                                            <div key={index} onClick={() => {set_jurusan(item.nama)}} className="_item" style={{backgroundColor: jurusan === item.nama ? '#eee' : null}}>{decode(item.nama)}</div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Tingkatan Kelas
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_column">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            onChange={e => set_tingkatan_kelas(e.target.value)}
                                                                            value={tingkatan_kelas}
                                                                        />
                                                                    </div>
                                                                    <div onClick={() => {
                                                                        if(sub_element === 'dropdown_tingkatan_kelas'){
                                                                            set_sub_element(null)
                                                                        }else{
                                                                            set_sub_element('dropdown_tingkatan_kelas')
                                                                        }
                                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_tingkatan_kelas' ? '#eee' : null}}>
                                                                        <div className="_row _center_align">
                                                                            <div className="_push_t_t">
                                                                                {
                                                                                    sub_element === 'dropdown_tingkatan_kelas' ?
                                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                    :
                                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_relative">
                                                                    {
                                                                        sub_element === 'dropdown_tingkatan_kelas' ?
                                                                            // _left or _right
                                                                            <>
                                                                                <div className="_fmc_overlay_dropdown _right">
                                                                                    {
                                                                                        data_tingkatan_kelas && data_tingkatan_kelas.list.map((item, index) => (
                                                                                            <div key={index} onClick={() => {set_tingkatan_kelas(item.tingkatan_kelas_romawi)}} className="_item" style={{backgroundColor: tingkatan_kelas === item.tingkatan_kelas_romawi ? '#eee' : null}}>{decode(item.tingkatan_kelas_romawi)}</div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Kelas
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_column">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            onChange={e => set_kelas(e.target.value)}
                                                                            value={kelas}
                                                                        />
                                                                    </div>
                                                                    <div onClick={() => {
                                                                        if(sub_element === 'dropdown_kelas'){
                                                                            set_sub_element(null)
                                                                        }else{
                                                                            set_sub_element('dropdown_kelas')
                                                                        }
                                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_kelas' ? '#eee' : null}}>
                                                                        <div className="_row _center_align">
                                                                            <div className="_push_t_t">
                                                                                {
                                                                                    sub_element === 'dropdown_kelas' ?
                                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                    :
                                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_relative">
                                                                    {
                                                                        sub_element === 'dropdown_kelas' ?
                                                                            // _left or _right
                                                                            <>
                                                                                <div className="_fmc_overlay_dropdown _right">
                                                                                    {
                                                                                        data_kelas && data_kelas.list.map((item, index) => (
                                                                                            <div key={index} onClick={() => {set_kelas(item.kelas)}} className="_item" style={{backgroundColor: kelas === item.kelas ? '#eee' : null}}>{decode(item.kelas)}</div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Orang Tua
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_orang_tua(e.target.value)}
                                                                    value={orang_tua}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Email
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_email(e.target.value)}
                                                                    value={email}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                No.Hp
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'number'} 
                                                                    onChange={e => set_no_hp(e.target.value)}
                                                                    value={no_hp}
                                                                />
                                                            </div>
                                                        </div>
                                                        <p className="_push_b_d _cl_smooth_0">Username dan Password diambil dari NIS. <br/>Dapat diubah oleh siswa.</p>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Username
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_username(e.target.value)}
                                                                    value={username}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Password
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'password'} 
                                                                    onChange={e => set_password(e.target.value)}
                                                                    value={password}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Alamat
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_alamat(e.target.value)}
                                                                    value={alamat}
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Input
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_push_r_t">
                                                                        Rp.
                                                                    </div>
                                                                    <div className="_column">
                                                                        <CurrencyFormat 
                                                                            value={input} 
                                                                            thousandSeparator={true} 
                                                                            prefix={''}
                                                                            onValueChange={(e) => {
                                                                                if(e.value.length < 10){
                                                                                    set_input(e.value)
                                                                                }else{
                                                                                    set_input('')
                                                                                    error('Max Length')
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Tahun
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_column">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            onChange={e => set_tingkatan_kelas(e.target.value)}
                                                                            value={tahun}
                                                                        />
                                                                    </div>
                                                                    <div onClick={() => {
                                                                        if(sub_element === 'dropdown_tahun'){
                                                                            set_sub_element(null)
                                                                        }else{
                                                                            set_sub_element('dropdown_tahun')
                                                                        }
                                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_tahun' ? '#eee' : null}}>
                                                                        <div className="_row _center_align">
                                                                            <div className="_push_t_t">
                                                                                {
                                                                                    sub_element === 'dropdown_tahun' ?
                                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                    :
                                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="_relative">
                                                                    {
                                                                        sub_element === 'dropdown_tahun' ?
                                                                            // _left or _right
                                                                            <>
                                                                                <div className="_fmc_overlay_dropdown _right">
                                                                                    {
                                                                                        data_tahun && data_tahun.list.map((item, index) => (
                                                                                            <div key={index} onClick={() => {set_tahun(item.tahun)}} className="_item" style={{backgroundColor: tahun === item.tahun ? '#eee' : null}}>{decode(item.tahun)}</div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div onClick={() => {
                                                            // _uploads_post(`insert_${request_params}`)
                                                            _uploads(`insert_${request_params}`)
                                                        }} className="_btn _cursor_pointer">
                                                            Simpan
                                                        </div>
                                                    </div>
                                                    <div className="_fmc_overlay_bg_hide">
                                                        <img style={{width: 400}} src={OverlayBg}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        : null
                    }
                </div>
            </div>
            {/*  Add ---------------------------------------------------------------------- */}

            {/*  Delete & Update ---------------------------------------------------------- */}
            {
                bamboo_delete.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Hapus Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_delete('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Data Akan Dihapus Pada Server Kami.</span>
                                            </div>
                                            <div onClick={() => {
                                                _uploads(`delete_${request_params}`)
                                            }} className="_btn _cursor_pointer">
                                                Hapus
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {
                bamboo_update.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar _no_print">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Detail</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_update('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div>
                                <div className="_row _push_t_m _push_b_g">
                                    <div className="_column">
                                        <div className="_row _center_align">
                                            <div className="_column _relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    NIS
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => {
                                                            set_nis(e.target.value)
                                                        }}
                                                        value={nis}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_column _relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    NISN
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_nisn(e.target.value)}
                                                        value={nisn}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="_relative _push_b_d">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Nama
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'text'} 
                                                    onChange={e => set_nama(e.target.value)}
                                                    value={nama}
                                                />
                                            </div>
                                        </div>
                                        <div className="_relative _push_b_d">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Tempat Lahir
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'text'} 
                                                    onChange={e => set_tempat_lahir(e.target.value)}
                                                    value={tempat_lahir}
                                                />
                                            </div>
                                        </div>
                                        <div className="_row _center_align">
                                            <div className="_column _relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Tanggal Lahir
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_tanggal_lahir(e.target.value)}
                                                        value={tanggal_lahir}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_column _relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Jenis Kelamin
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_jenis_kelamin(e.target.value)}
                                                        value={jenis_kelamin}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="_relative _push_b_d">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Jurusan
                                            </p>
                                            <div className="_e_input">
                                                <div className="_row _center_align">
                                                    <div className="_column">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_jurusan(e.target.value)}
                                                            value={jurusan}
                                                        />
                                                    </div>
                                                    <div onClick={() => {
                                                        if(sub_element === 'dropdown_jurusan'){
                                                            set_sub_element(null)
                                                        }else{
                                                            set_sub_element('dropdown_jurusan')
                                                        }
                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_jurusan' ? '#eee' : null}}>
                                                        <div className="_row _center_align">
                                                            <div className="_push_t_t">
                                                                {
                                                                    sub_element === 'dropdown_jurusan' ?
                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                    :
                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="_relative">
                                                    {
                                                        sub_element === 'dropdown_jurusan' ?
                                                            // _left or _right
                                                            <>
                                                                <div className="_fmc_overlay_dropdown _right">
                                                                    {
                                                                        data_jurusan && data_jurusan.list.map((item, index) => (
                                                                            <div key={index} onClick={() => {set_jurusan(item.nama)}} className="_item" style={{backgroundColor: jurusan === item.nama ? '#eee' : null}}>{decode(item.nama)}</div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </>
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="_relative _push_b_d">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Tingkatan Kelas
                                            </p>
                                            <div className="_e_input">
                                                <div className="_row _center_align">
                                                    <div className="_column">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_tingkatan_kelas(e.target.value)}
                                                            value={tingkatan_kelas}
                                                        />
                                                    </div>
                                                    <div onClick={() => {
                                                        if(sub_element === 'dropdown_tingkatan_kelas'){
                                                            set_sub_element(null)
                                                        }else{
                                                            set_sub_element('dropdown_tingkatan_kelas')
                                                        }
                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_tingkatan_kelas' ? '#eee' : null}}>
                                                        <div className="_row _center_align">
                                                            <div className="_push_t_t">
                                                                {
                                                                    sub_element === 'dropdown_tingkatan_kelas' ?
                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                    :
                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="_relative">
                                                    {
                                                        sub_element === 'dropdown_tingkatan_kelas' ?
                                                            // _left or _right
                                                            <>
                                                                <div className="_fmc_overlay_dropdown _right">
                                                                    {
                                                                        data_tingkatan_kelas && data_tingkatan_kelas.list.map((item, index) => (
                                                                            <div key={index} onClick={() => {set_tingkatan_kelas(item.tingkatan_kelas_romawi)}} className="_item" style={{backgroundColor: tingkatan_kelas === item.tingkatan_kelas_romawi ? '#eee' : null}}>{decode(item.tingkatan_kelas_romawi)}</div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </>
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="_relative _push_b_d">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Kelas
                                            </p>
                                            <div className="_e_input">
                                                <div className="_row _center_align">
                                                    <div className="_column">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_kelas(e.target.value)}
                                                            value={kelas}
                                                        />
                                                    </div>
                                                    <div onClick={() => {
                                                        if(sub_element === 'dropdown_kelas'){
                                                            set_sub_element(null)
                                                        }else{
                                                            set_sub_element('dropdown_kelas')
                                                        }
                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_kelas' ? '#eee' : null}}>
                                                        <div className="_row _center_align">
                                                            <div className="_push_t_t">
                                                                {
                                                                    sub_element === 'dropdown_kelas' ?
                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                    :
                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="_relative">
                                                    {
                                                        sub_element === 'dropdown_kelas' ?
                                                            // _left or _right
                                                            <>
                                                                <div className="_fmc_overlay_dropdown _right">
                                                                    {
                                                                        data_kelas && data_kelas.list.map((item, index) => (
                                                                            <div key={index} onClick={() => {set_kelas(item.kelas)}} className="_item" style={{backgroundColor: kelas === item.kelas ? '#eee' : null}}>{decode(item.kelas)}</div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </>
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="_relative _push_b_d">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Orang Tua
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'text'} 
                                                    onChange={e => set_orang_tua(e.target.value)}
                                                    value={orang_tua}
                                                />
                                            </div>
                                        </div>
                                        <div className="_row _center_align">
                                            <div className="_column _relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Email
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_email(e.target.value)}
                                                        value={email}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_column _relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    No.Hp
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'number'} 
                                                        onChange={e => set_no_hp(e.target.value)}
                                                        value={no_hp}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="_relative _push_b_d">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Alamat
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'text'} 
                                                    onChange={e => set_alamat(e.target.value)}
                                                    value={alamat}
                                                />
                                            </div>
                                        </div>
                                        
                                        {/* <div className="_relative _push_b_d">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Input
                                            </p>
                                            <div className="_e_input">
                                                <div className="_row _center_align">
                                                    <div className="_push_r_t">
                                                        Rp.
                                                    </div>
                                                    <div className="_column">
                                                        <CurrencyFormat 
                                                            value={input} 
                                                            thousandSeparator={true} 
                                                            prefix={''}
                                                            onValueChange={(e) => {
                                                                if(e.value.length < 10){
                                                                    set_input(e.value)
                                                                }else{
                                                                    set_input('')
                                                                    error('Max Length')
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="_relative _push_b_d">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Tahun
                                            </p>
                                            <div className="_e_input">
                                                <div className="_row _center_align">
                                                    <div className="_column">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_tingkatan_kelas(e.target.value)}
                                                            value={tahun}
                                                        />
                                                    </div>
                                                    <div onClick={() => {
                                                        if(sub_element === 'dropdown_tahun'){
                                                            set_sub_element(null)
                                                        }else{
                                                            set_sub_element('dropdown_tahun')
                                                        }
                                                    }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'dropdown_tahun' ? '#eee' : null}}>
                                                        <div className="_row _center_align">
                                                            <div className="_push_t_t">
                                                                {
                                                                    sub_element === 'dropdown_tahun' ?
                                                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                                                    :
                                                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="_relative">
                                                    {
                                                        sub_element === 'dropdown_tahun' ?
                                                            // _left or _right
                                                            <>
                                                                <div className="_fmc_overlay_dropdown _right">
                                                                    {
                                                                        data_tahun && data_tahun.list.map((item, index) => (
                                                                            <div key={index} onClick={() => {set_tahun(item.tahun)}} className="_item" style={{backgroundColor: tahun === item.tahun ? '#eee' : null}}>{decode(item.tahun)}</div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </>
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div onClick={() => {
                                            window.print()
                                        }} className="_btn _cursor_pointer">
                                            Print
                                        </div>
                                    </div>
                                    <div className="_fmc_overlay_bg_hide _no_print">
                                        <img style={{width: 400}} src={OverlayBg}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {/*  End Delete & Update ------------------------------------------------------- */}


            <div className="_row_auto _center_align _push_b_d _no_print" style={{marginLeft: -10, marginRight: -10}}>
                <div className="_row _center_align">
                    <div className="_push_r_m" style={{marginLeft: 10}}>
                        <div className="_relative">
                            <div onClick={() => {
                                if(element === 'dropdown_filter_kelas'){
                                    set_element(null)
                                }else{
                                    set_element('dropdown_filter_kelas')
                                }
                            }} className="_btn _cursor_pointer" style={{backgroundColor: element === 'dropdown_filter_kelas' ? '#eee' : null,  borderColor: '#eee', borderRadius: 0, paddingTop: 12, paddingBottom: 12}}>
                                <div className="_row _center_align">
                                    <div className="_column">
                                        {filter_kelas.length > 0 ? filter_kelas : 'Kelas'}
                                    </div>
                                    <div className="_push_l_m _push_t_t">
                                        {
                                            element === 'dropdown_filter_kelas' ?
                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                            :
                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                element === 'dropdown_filter_kelas' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left">
                                            {
                                                data_kelas && data_kelas.list.map((item, index) => (
                                                    <div key={index} onClick={() => {set_filter_kelas(item.kelas)}} className="_item" style={{backgroundColor: filter_kelas === item.kelas ? '#eee' : null}}>{item.kelas}</div>
                                                ))
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    </div>
                    <div style={{marginRight: 10}}>
                        <div className="_relative">
                            <div onClick={() => {
                                if(element === 'dropdown_filter_tahun'){
                                    set_element(null)
                                }else{
                                    set_element('dropdown_filter_tahun')
                                }
                            }} className="_btn _cursor_pointer" style={{backgroundColor: element === 'dropdown_filter_tahun' ? '#eee' : null,  borderColor: '#eee', borderRadius: 0, paddingTop: 12, paddingBottom: 12}}>
                                <div className="_row _center_align">
                                    <div className="_column">
                                        {filter_tahun.length > 0 ? filter_tahun : 'Tahun'}
                                    </div>
                                    <div className="_push_l_m _push_t_t">
                                        {
                                            element === 'dropdown_filter_tahun' ?
                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                            :
                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                element === 'dropdown_filter_tahun' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left">
                                            {
                                                data_tahun && data_tahun.list.map((item, index) => (
                                                    <div key={index} onClick={() => {set_filter_tahun(item.tahun)}} className="_item" style={{backgroundColor: filter_tahun === item.tahun ? '#eee' : null}}>{item.tahun}</div>
                                                ))
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    </div>
                </div>
                <div className="_column_auto">
                    {/*  Search -------------------------------------------------------------------- */}
                    <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                        <div className="_row _center_align">
                            <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                            <div className="_column">
                                <input 
                                    placeholder="Cari NIS" 
                                    onChange={e => set_search(e.target.value)}
                                    value={search}
                                />
                            </div>
                        </div>
                    </div>
                    {/*  End Search ---------------------------------------------------------------- */}
                </div>
            </div>

            {/*  Table --------------------------------------------------------------------- */}
            <div className="_overflow_x">
                <table className="_table">
                    <thead>
                        <tr>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            {/* <th>Foto</th> */}
                            <th>NIS</th>
                            <th>Nama</th>
                            <th>Email</th>
                            <th>No.Hp</th>
                            <th>Kelas</th>
                            <th>Tahun</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data && data.list.length > 0 ? 
                                data.list.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        {/* <td>
                                            <a href={API_SERVER + '/' + item.path + '/' + item.foto} target="_blank"><ion-icon name="image-outline" style={{fontSize: 22, marginBottom: -3}}></ion-icon></a>
                                        </td> */}
                                        <td>{decode(item.nis)}</td>
                                        <td>{decode(item.nama)}</td>
                                        <td>{decode(item.email)}</td>
                                        <td>{decode(item.no_hp)}</td>
                                        <td>{decode(item.kelas)}</td>
                                        <td>{decode(item.tahun)}</td>
                                        <td>
                                            <div className="_right_text _text_overflow">
                                                {/* <div onClick={() => {
                                                    set_path_client(item.path)
                                                    set_bamboo_delete(item.bamboo)
                                                }} className="_btn _cursor_pointer _push_r_m">
                                                    Delete
                                                </div> */}
                                                <div onClick={() => {
                                                    set_path_client(item.path)
                                                    set_bamboo_update(item.bamboo)
                                                    // update state -------------------------
                                                    set_test(item.kode)
                                                    set_nis(item.nis)
                                                    set_nisn(item.nisn)
                                                    set_nama(item.nama)
                                                    set_tempat_lahir(item.tempat_lahir)
                                                    set_tanggal_lahir(item.tanggal_lahir)
                                                    set_jenis_kelamin(item.jenis_kelamin)
                                                    set_jurusan(item.jurusan)
                                                    set_tingkatan_kelas(item.tingkatan_kelas)
                                                    set_kelas(item.kelas)
                                                    set_orang_tua(item.orang_tua)
                                                    set_email(item.email)
                                                    set_no_hp(item.no_hp)
                                                    set_alamat(item.alamat)
                                                    set_tahun(item.tahun)
                                                }} className="_btn _cursor_pointer _push_r_m">
                                                    Detail
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))

                            :
                                data &&
                                <tr>
                                    <td colSpan="10">Belum Ada Data</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            {/*  End Table ----------------------------------------------------------------- */}

            {/*  Pagination ---------------------------------------------------------------- */}
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1, bamboo_user);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>
            {/*  End Pagination -------------------------------------------------------------*/}

            {/*  Credit -------------------------------------------------------------------- */}
            {
                data && 
                    data.pages.length === 1 ?
                        <ComponentsCredit/>
                    :
                        data && data.list.length > 0 ?
                            null
                        :
                            <ComponentsCredit/>
                            
            }
            {/*  End Credit ---------------------------------------------------------------- */}

            {/*  Documentation ------------------------------------------------------------- */}

                {/* <div className="_row _center_align">
                    <div className="_column">

                    </div>
                    <div className="_column">
                        
                    </div>
                </div> */}

                {/* <div onClick={() => {
                    if(element === 'overlay'){
                        set_element(null)
                    }else{
                        set_element('overlay')
                    }
                }} className="_btn _cursor_pointer">
                    fmc overlay btn
                </div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Overlay</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">

                                </div>
                            </div>
                        </>
                    : null
                }

                <div className="_relative">
                    <div onClick={() => {
                        if(element === 'overlay_dropdown'){
                            set_element(null)
                        }else{
                            set_element('overlay_dropdown')
                        }
                    }} className="_btn _cursor_pointer">
                        <div className="_row _center_align">
                            <div className="_column">
                                fmc overlay dropdown btn
                            </div>
                            <div className="_push_l_m _push_t_t">
                                {
                                    element === 'overlay_dropdown' ?
                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                    :
                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        element === 'overlay_dropdown' ?
                            // _left or _right
                            <>
                                <div className="_fmc_overlay_dropdown _left">
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                </div>
                            </>
                        : null
                    }
                </div>

                <div className="_relative _push_b_m">
                    <p style={{color: '#888', fontSize: 13}}>
                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                        Input
                    </p>
                    <div className="_e_input">
                        <input 
                            placeholder=""
                            type={'text'} 
                            // onChange={e => set_input(e.target.value)}
                            // value={input}
                        />
                    </div>
                </div>

                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                        
                    <input
                        className="custom-file-input" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files}
                    />

                </div>

                <div onClick={() => {
                    _uploads()
                }} className="_btn _cursor_pointer">
                    Simpan
                </div>

                <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div className="_overflow_x">
                    <table className="_table">
                        <thead>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="_lily_pad_h_d _push_b_d _push_t_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}
                
            {/*  End Documentation --------------------------------------------------------- */}
            
            {/*  Stuck --------------------------------------------------------------------- */}
            {/* <div style={{height: 100}}></div> */}
            {/*  End Stuck ----------------------------------------------------------------- */}

        </div>
    );

}

export default Screen;